<template>
  <TareaModal :isPossibleAdditional="isPossibleAdditional" />
</template>

<script>
import TareaModal from './Tasks/TareaModal'

export default {
  name: 'TaskDetailModal',
  components: { TareaModal },
  props: {
    isPossibleAdditional: {
      type: Boolean,
      default: undefined
    }
  }
}
</script>